import Logo from "@assets/logo/logo-dnk.svg?react";
import Error from "../Error";
import Button from "../common/Button";

type BannedProps = {
	logoutWithReturnTo: () => void;
};

function Banned({ logoutWithReturnTo }: BannedProps) {
	return (
		<div className="p-8 bg-primary-blue text-white h-full flex flex-col items-center justify-center gap-8">
			<Logo className="w-32" />
			<Error>
				<h1 className="text-2xl font-bold font-sans mb-4">
					Account Banned
				</h1>
				<p>Your account has been banned.</p>
				<p>
					Please <a href="mailto:dnks@warrisk.no">contact support</a>{" "}
					for more information.
				</p>
				<div className="flex items-center justify-center mt-4">
					<Button variant="primary" onClick={logoutWithReturnTo}>
						Log out
					</Button>
				</div>
			</Error>
		</div>
	);
}
export default Banned;
